import { OrderedMap } from 'immutable';
import { registerQuery, useQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import http from 'hub-http/clients/apiClient';
import getEarlyRequest from 'automation-ui-enrollment/utils/getEarlyRequest';
import ObjectType from 'automation-ui-references/object-types/ObjectType';
import { getObjectTypeId } from 'automation-ui-references/object-types/objectTypeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const earlyRequestName = 'object-types';
const formatObjectTypesResponse = response => {
  if (!Array.isArray(response)) {
    throw new Error('Unexpected response');
  }
  return response.reduce((entityMap, currentEntity) => {
    const objectType = new ObjectType(currentEntity);
    return entityMap.set(getObjectTypeId(objectType), objectType);
  }, OrderedMap());
};
export const GET_OBJECT_TYPE_BY_ID = registerQuery({
  fieldName: 'enrollment_objectTypeById',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http
    // TODO: Fix this generic parameter, we don't get immutable data back from an API
    .get(`inbounddb-meta/v1/object-types/${objectTypeId}`).then(response => new ObjectType(response));
  }
});
export const GET_BATCH_OBJECT_TYPE_BY_ID = registerQuery({
  fieldName: 'enrollment_batchObjectTypesById',
  args: ['objectTypeIds'],
  fetcher({
    objectTypeIds
  }) {
    return http.get(`inbounddb-meta/v1/object-types/batch-get/`, {
      query: {
        objectType: objectTypeIds
      }
    }).then(formatObjectTypesResponse);
  }
});
export const GET_ALL_OBJECT_TYPES = registerQuery({
  fieldName: 'enrollment_allObjectTypes',
  fetcher: () => getEarlyRequest({
    key: earlyRequestName,
    defaultRequestFn: () => http.get(`inbounddb-meta/v1/object-types/for-portal`)
  }).then(formatObjectTypesResponse)
});
export const queryAllObjectTypes = WrappedComponent => props => {
  const {
    data,
    loading
  } = useQuery(GET_ALL_OBJECT_TYPES);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    allObjectTypes: get(data, 'enrollment_allObjectTypes', OrderedMap()),
    allObjectTypesLoading: loading
  }));
};